import { useContext } from 'react'
import { SessionContext, type SessionContextValue } from './session-context'

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext)
  if (!value) throw new Error('useSession은 SessionProvider 안에서만 쓴다')
  return value
}
